export class GPADetails {
   GPAName: string;
   GPAAadhar: string;
   GPAGender: string;
   GPARelationType: string;
   GPARelationName: string;
   GPAAge: number;
   GPAAddress: string;
   GPACity: string;
   GPAState: string;
   GPACountryId: number;
   GPADocumentNo: string;
   GPADocumentDate: Date;
   GPARegdPlace: string;  
   GPAPincode: string    
  GPARelation: string;
  AddressProofFile: File;
  AddressProofDocName: string;
  IdProofFile: File;
  IDProofDocName: string;
}

